import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import ConfirmationModal from 'components/modals/ConfirmationModal';


const useStyles = makeStyles(theme => ({
  question: {
    fontWeight: 500,
    fontSize: '1rem',
    color: theme.palette.secondary.text,
  },
  warningWrapper: {
    marginTop: '1.5rem',
    backgroundColor: theme.palette.blue['100'],
    borderRadius: '0.375rem',
    padding: '0.75rem',
  },
  warningTitle: {
    display: 'block',
    fontWeight: 600,
    fontSize: '0.625rem',
    color: theme.palette.primaryCTA.main,
    textTransform: 'uppercase',
    letterSpacing: '0.01rem',
  },
  warningText: {
    display: 'block',
    fontWeight: 400,
    fontSize: '0.875rem',
    color: theme.palette.secondary['900'],
    letterSpacing: '-0.01rem',
    lineHeight: '125%',
  },
}));


const EmailConfigDeleteConfirm = ({
  isOpen, onConfirmClick, toggle, confirmLabel, confirmBtnColor,
}) => {
  const classes = useStyles();
  return (
    <ConfirmationModal
      open={isOpen}
      onBackdropClick={toggle}
      title="Confirm"
      size={440}
      cancelLabel="No, cancel"
      confirmLabel={confirmLabel}
      confirmBtnColor={confirmBtnColor}
      onConfirmClick={onConfirmClick}
      onCancelClick={toggle}
    >
      <span className={classes.question}>Are you sure you want to remove this sending email address?</span>
      <div className={classes.warningWrapper}>
        <span className={classes.warningTitle}>Warning</span>
        <span>
        Contacts that received emails from this email address will
        receive future follow-ups from the other email address(es).
        </span>
      </div>
    </ConfirmationModal>
  );
};

EmailConfigDeleteConfirm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string,
  confirmBtnColor: PropTypes.string,
};

EmailConfigDeleteConfirm.defaultProps = {
  confirmLabel: 'Yes, delete email',
  confirmBtnColor: 'accent3',
};

export default EmailConfigDeleteConfirm;
